import React, { useMemo } from "react";
import { withTranslation } from "react-i18next";
import { Col, Row } from "reactstrap";
import { get } from "lodash";
import PropTypes from "prop-types";

import Collapse from "./Collapse";
import moment from "moment";
import { convertUTCDateToLocalDate } from "utils/convertUTCDateToLocalDate";
import { getOptionLabel } from "common/enums";

const AccessCardDetailView = ({ accessHolderData, isExpandable = true, t }) => {
  const {
    accessRequiredFrom,
    accessRequiredTo,
    expectedReturnDate,
    accessCardHolderType,
    employeeContractorDetail,
  } = accessHolderData;

  const { workingHoursFrom, workingHoursTo } = employeeContractorDetail || {};

  const isEmployee =
    getOptionLabel("utilityTunnelConsumerType", accessCardHolderType) ===
    "Employee";

  const fields = useMemo(
    () => [
      {
        name: "Block",
        key: "block.name",
        isRequired: true,
      },
      {
        name: "Location",
        key: "utaCardIssuanceLocation.name",
        isRequired: true,
      },
      {
        name: "Door",
        key: "door.name",
        isRequired: true,
      },
      {
        name: "Access Required From",
        renderField: () =>
          moment(accessRequiredFrom).isValid()
            ? convertUTCDateToLocalDate(accessRequiredFrom).format("DD-MM-YYYY")
            : "N/A",
      },
      {
        name: "Access Required To",
        renderField: () =>
          moment(accessRequiredTo).isValid()
            ? convertUTCDateToLocalDate(accessRequiredTo).format("DD-MM-YYYY")
            : "N/A",
      },
      ...(!isEmployee
        ? [
            {
              name: "Expected Return Date",
              renderField: () =>
                moment(expectedReturnDate).isValid()
                  ? convertUTCDateToLocalDate(expectedReturnDate).format(
                      "DD-MM-YYYY"
                    )
                  : "N/A",
            },
            {
              name: "Working Hours From",
              renderField: () =>
                moment(workingHoursFrom ).isValid()
                  ? moment(workingHoursFrom).format(
                      "HH:mm"
                    )
                  : "N/A",
            },
            {
              name: "Working Hours To",
              renderField: () =>
                moment(workingHoursTo).isValid()
                  ? moment(workingHoursTo).format(
                      "HH:mm"
                    )
                  : "N/A",
            },
          ]
        : []),
    ],
    []
  );

  return (
    <>
      <Collapse title="Access Details" isExpandable={isExpandable}>
        <Row className="d-flex  mb-2">
          {fields.map(({ name, key, isRequired, renderField }) => {
            const value = get(accessHolderData, key, "");
            return (
              <Col key={key} lg={6} className="mb-1">
                <Row>
                  <Col md={5}>{t(name)}:</Col>
                  <Col
                    md={7}
                    className="fw-semibold"
                    style={{ wordBreak: "break-word" }}
                  >
                    {renderField
                      ? renderField(value)
                      : get(accessHolderData, key, null) ??
                        (isRequired ? "-" : "N/A")}
                  </Col>
                </Row>
              </Col>
            );
          })}
        </Row>
      </Collapse>
    </>
  );
};

AccessCardDetailView.propTypes = {
  accessHolderData: PropTypes.object,
  isExpandable: PropTypes.bool,
  accessCardHolderType: PropTypes.number,
  t: PropTypes.func,
};

export default withTranslation()(AccessCardDetailView);
